import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function Hero() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const slides = [
        { image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1920&q=80' },
        { image: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=1920&q=80' },
        { image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=1920&q=80' }
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);
        return () => clearInterval(timer);
    }, [slides.length]);

    return (
        <div className="hero-section" data-testid="hero-section">
            <div className="hero-slider">
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
                        style={{ backgroundImage: `url(${slide.image})` }}
                    />
                ))}
            </div>
            <div className="hero-overlay" />
            <div className="hero-content">
                <h1 className="hero-title" data-testid="hero-title">Laxmi Finsec Consultant Pvt. Ltd.</h1>
                <Link to="/contact">
                    <Button size="lg" variant="outline" className="hero-btn" data-testid="hero-apply-btn">
                        Apply Now <ArrowRight className="ml-2" size={20} />
                    </Button>
                </Link>
            </div>
            <div className="hero-indicators">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        className={`indicator ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => setCurrentSlide(index)}
                        data-testid={`hero-indicator-${index}`}
                    />
                ))}
            </div>
        </div>
    );
};
